import { Link } from "react-router-dom";

const ButtonBack = ({ to }) => {
    return (
        <Link to={to} className="btn-header btn-header--back">
            <i className="fa-regular fa-arrow-left-from-line"></i>
        </Link>
    );
};

export default ButtonBack;
